<template>
    <div>
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Scopes</h1>
                    <p>Gestion des worspaces de connexion</p>
                </div>

                <div class="actions">
                    <ul>
                        <li><button class="bt-primary" @click="create()"><i class="icon icon-icon_person-add"></i><span>Créer</span></button></li>
                    </ul>
                </div>

            </div>
        </header>
        <div class="content-body">

            <section>
            <div class="search">
                <div><input type="text" placeholder="Recherche" v-model="query"/></div>
            </div>

            <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

            <div class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div v-bind:class="[ paginator.sort == 'name' ? 'active' : '', paginator.order ]">
                            <span data-sort="name" @click="setOrder($event)">Nom</span>
                        </div>
                        <div class="slug center">Slug</div>
                        <div class="parent center">Parent scope</div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)">
                        <div></div>
                        <div class="picture">
                            <figure>
                                <i v-if="!item.picture" class="icon icon-icon_layers"></i>
                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="name"><strong>{{ item.name }}</strong><p>{{ item.description }}</p></div>
                        <div data-field="slug" class="center"><label class="label scope" v-bind:style="{background:item.color}">{{ item.slug.substr(0,1) }}</label></div>
                        <div data-field="parent" class="center"><label class="label scope" v-if="item.parent" v-bind:style="{background:item.parent.color}">{{ item.parent.slug.substr(0,1) }}</label></div>
                        <div class="actions">
                            <ul>
                                <li><button @click="remove(item.id)"><i class="icon icon-icon_delete"></i></button></li>
                                <li><button @click="edit(item.id)"><i class="icon icon-icon_pencil"></i></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import ScopeService from './ScopeService.js';
    import Index from '../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return {name: 'scope', api: ScopeService};
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/scope/Index.vue